import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Tooltip } from "components";
import ExclamationCircleIcon from "assets/icons/ExclamationCircle";
import { getValueFromPath } from "utils";
import useThemeStore from "(store)/themeStore";

const InputField = ({
  name,
  label,
  type = "text",
  size = "small",
  placeholder,
  tooltipValue,
  isRequired = false,
  disabled = false,
  isDynamic = false,
}) => {
  const { errors, touched, setFieldValue } = useFormikContext();
  const theme = useThemeStore((state) => state.theme);
  const isThemeDark = theme === "dark";
  const showError =
    (isDynamic ? getValueFromPath(errors, name) : errors[name]) &&
    (isDynamic ? getValueFromPath(touched, name) : touched[name]);

  const handleZipChange = (e, setFieldValue) => {
    const { value } = e.target;
    if (value.length <= 5 && value !== "") {
      setFieldValue("zip", value);
    }
  };
  return (
    <div className="form-control w-full">
      {label && (
        <div className="flex items-center gap-1 mb-1">
          <span className="flex gap-1 items-end relative">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
          {tooltipValue && (
            <Tooltip
              children={<ExclamationCircleIcon color={"red"} />}
              message={tooltipValue}
            />
          )}
        </div>
      )}
      {name === "zip" ? (
        <Field
          name={name}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) =>
            name === "zip" ? handleZipChange(e, setFieldValue) : undefined
          }
          className={`flex w-full px-3 ${
            size === "large" ? "py-3" : "py-2"
          } border border-gray-300 placeholder-[#979797] rounded-lg focus:outline-none 
          ${
            isThemeDark
              ? "focus-within:text-black text-gray-300 focus-within:bg-white bg-slate-950"
              : "bg-white text-gray-900"
          }
          ${
            showError
              ? "focus-within:border-red-500 border-red-500"
              : `${
                  isThemeDark
                    ? "focus-within:border-[#FAB54E]"
                    : "focus-within:border-[#1996A6]"
                }`
          } 
          focus:z-10 sm:text-sm ${
            disabled
              ? `bg-gray-100 ${
                  isThemeDark ? "bg-gray-800 text-gray-500" : ""
                } cursor-not-allowed text-slate-400 placeholder:text-slate-400`
              : ""
          } `}
        />
      ) : (
        <Field
          name={name}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          className={`flex w-full px-3 ${
            size === "large" ? "py-3" : "py-2"
          } border border-gray-300 placeholder-gray-500 rounded-lg focus:outline-none
          ${
            isThemeDark
              ? "bg-slate-950 focus-within:text-black text-gray-300 focus-within:bg-white  "
              : "bg-white text-gray-900"
          }
          ${
            showError
              ? "focus-within:border-red-500 border-red-500"
              : `${
                  isThemeDark
                    ? "focus-within:border-[#FAB54E]"
                    : "focus-within:border-[#1996A6]"
                } `
          } 
          focus:z-10 sm:text-sm ${
            disabled
              ? `bg-gray-100 ${
                  isThemeDark ? "bg-gray-800 text-gray-500" : ""
                } cursor-not-allowed text-slate-400 placeholder:text-slate-400`
              : ""
          } `}
        />
      )}

      <ErrorMessage
        className="text-xs text-red-500 mt-1"
        name={name}
        component="div"
      />
    </div>
  );
};

export default InputField;
